import React from "react";
import Button from "../components/button";
import Layout from "../components/layout";

export default function NotFoundPage() {
  return (
    <Layout>
      <div className="not-found">
        <span className="not-found__code">404</span>
        <h1 className="not-found__title">Page not found</h1>
        <p className="not-found__text">
          The page you're looking for doesn't exist or may have been moved.
        </p>
        <Button to="/">Back to home</Button>
      </div>
    </Layout>
  );
}
